import React from 'react';

import './header.styles.scss';

export default function Header() {
  return (
    <header className='header-container'>
      <div className='header-db' />
      <div className='header-logos'>
        <a href='https://www.cisa.sc.edu/'>
          <div className='cisa-logo'>
            <img
              src={process.env.PUBLIC_URL + '/logos/CISAlogo.svg'}
              alt='Organization logo for CISA, a NOAA RISA team'
            />
          </div>
        </a>
        <a href='https://www.midatlanticrisa.org/'>
          <div className='marisa-logo'>
            <img
              src={process.env.PUBLIC_URL + '/logos/MARISAlogo.svg'}
              alt='Organization logo for MARISA, a NOAA RISA team'
            />
          </div>
        </a>
        <a href='https://glisa.umich.edu/'>
          <div className='glisa-logo'>
            <img
              src={process.env.PUBLIC_URL + '/logos/GLISAlogo.png'}
              alt='Organization logo for GLISA, a NOAA RISA team'
            />
          </div>
        </a>
      </div>
      <div className='header-title'>
        <div>Climate and Hazard Mitigation Planning (CHaMP) Tool</div>
      </div>
    </header>
  );
}
